<div *ngIf="subRegions.loading && !subRegions.detail" class="text-600">Loading…</div>
<div *ngIf="subRegions.error" class="err">{{ subRegions.error }}</div>
<ng-container *ngIf="subRegions.detail as d">
  <section class="first sr-members">
    <div class="lbl">Members <span class="meta-inline">{{ d.members.length | number }} suburb{{ d.members.length === 1 ? '' : 's' }}</span></div>
    <div *ngIf="!d.members.length" class="text-600 text-sm">None yet. Add suburbs on the map in Sub-region mode, from a suburb's panel, or below from council areas.</div>
    <ul class="plain member-list">
      <li *ngFor="let m of d.members" class="flex align-items-center gap-2" [attr.data-salcode]="m.salCode">
        <a class="flex-1 min-w-0 truncate cursor-pointer" (click)="nav.flyTo(m.salCode)">{{ m.name }} <span class="text-500 text-xs">{{ m.state }}{{ m.page ? ' · has a page' : '' }}</span></a>
        <button *ngIf="!state.readOnly" pButton type="button" icon="pi pi-times" class="p-button-text p-button-rounded p-button-sm member-remove" (click)="mapTools.membership(m.salCode, id, 'remove')" pTooltip="Take out" tooltipPosition="left"></button>
      </li>
    </ul>
    <div class="flex gap-2 mt-2">
      <button pButton type="button" class="p-button-sm p-button-outlined" icon="pi pi-map" label="Edit on the map" (click)="mapTools.editSubRegionOnMap(id)" [disabled]="state.readOnly"></button>
    </div>
  </section>

  <section class="website-page">
    <div class="lbl">Website page</div>
    <div class="page-state">
      <strong [class.ok]="subRegions.record?.published">{{ subRegions.record?.published ? 'On the website' : 'Not on the website' }}</strong>
      <span class="text-600 text-sm"> · /{{ d.region?.state | lowercase }}/{{ d.region?.slug }}/funeral-services/{{ d.slug }}</span>
    </div>
    <div *ngIf="subRegions.needsPublish" class="text-sm warn mt-1 publish-note">Its suburbs changed: publish to show the change on the website.</div>
    <div *ngIf="!state.readOnly" class="flex flex-wrap gap-2 mt-2">
      <button pButton type="button" class="p-button-sm p-button-success subregion-publish" icon="pi pi-cloud-upload" [label]="subRegions.record?.published ? 'Publish changes' : 'Publish'" (click)="publisher.publishSubRegion('publish')"></button>
      <button *ngIf="subRegions.record?.published" pButton type="button" class="p-button-sm p-button-outlined p-button-danger" icon="pi pi-eye-slash" label="Un-publish" (click)="publisher.publishSubRegion('unpublish')"></button>
      <button pButton type="button" class="p-button-sm p-button-outlined" icon="pi pi-pencil" label="Edit page" (click)="pageEditor.editSubRegionPage(id)"></button>
    </div>
    <div class="meta">Publishing ships just this sub-region's page to the website preview; production follows from the Website page.</div>
  </section>

  <section app-suburb-council-fill class="fill-councils"></section>

  <section *ngIf="gate as gate">
    <div class="lbl">Search gate <span class="meta-inline">report only</span></div>
    <div *ngIf="gate.main as m">
      <strong [class.ok]="m.pass" [class.warn]="!m.pass">{{ m.pass ? 'Passes' : 'Doesn\'t pass' }}</strong>
      <span class="text-600"> · indexed today: {{ m.indexableNow ? 'yes' : 'no' }}</span>
    </div>
    <div *ngIf="!gate.main" class="text-600 text-sm">No page in the last build.</div>
    <div class="meta">From the website build of {{ gate.reportedAt | date: 'd MMM y, h:mm a' }}. Indexing doesn't follow this yet.</div>
  </section>

  <section>
    <div class="lbl">Colour on the map</div>
    <div app-suburb-colour-picker class="colour-picker" [selected]="catalogue.colourOf(id)" [disabled]="state.readOnly" (pick)="subRegions.setColour(id, $event)"></div>
  </section>

  <section>
    <span [pTooltip]="subRegions.deleteBlock(id) || ''" tooltipPosition="top">
      <button pButton type="button" class="p-button-sm p-button-text p-button-danger sr-delete" icon="pi pi-trash" label="Delete sub-region" [disabled]="state.readOnly || !!subRegions.deleteBlock(id)" (click)="subRegions.delete(id)"></button>
    </span>
    <div *ngIf="subRegions.deleteBlock(id) as why" class="meta">{{ why }}</div>
  </section>
</ng-container>
